// UKG READY (MAIN, APPEND, & MERGE)
import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";
import {
  DATA_SOURCES_TEST_PREFIX,
  GetAdditionalTableFields,
  toggleValueInList
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { Checkbox, Flex, Input } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

export const UKGReadySetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  let { tables, ukgDetailed, useCustomEndpoint, customEndpoint } = config;
  const additionalFields = GetAdditionalTableFields(config.source);
  let additionalFieldOptions = additionalFields.map(table => {
    return { value: table, label: table };
  });
  // selected tables
  let selectedTables = tables ?? [];
  let selectedFieldOptions = selectedTables.map(table => {
    return { value: table, label: table };
  });
  const isAdditionalSource = importType !== "import";
  const atsType = isAdditionalSource ? enumATSModes.notATS : undefined;

  const onTableChange = e => {
    let option = e.value;
    const selectedList = toggleValueInList(selectedTables, option.value);
    onChange({ ...config, tables: selectedList });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={isAdditionalSource}
      showLoadHeaders={isAdditionalSource}
      showAdditionalFields
      selectedAdditionalFields={selectedFieldOptions}
      additionalFieldOptions={additionalFieldOptions}
      onAdditionalFieldChange={onTableChange}
      importType={importType}
      ATSType={atsType}
    >
      <Flex direction={"column"} gap={"8px"}>
        <Checkbox
          id={"detailed-pull-ukg"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-ukgready-detailed-query-checkbox`}
          label={appstr("Detailed data query")}
          size={"medium"}
          checked={ukgDetailed}
          onChange={() => onChange({ ...config, ukgDetailed: !ukgDetailed })}
        />
        <Checkbox
          id={"set-endpoint"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-ukgready-specify-endpoint-checkbox`}
          size={"medium"}
          label={appstr("Specify endpoint")}
          checked={useCustomEndpoint}
          onChange={() => {
            const toggle = !useCustomEndpoint;
            onChange({ ...config, useCustomEndpoint: toggle, customEndpoint: "" });
          }}
        />
        {useCustomEndpoint && (
          <Input
            id={"set-endpoint-input"}
            dataTestId={`${DATA_SOURCES_TEST_PREFIX}-ukgready-endpoint-input`}
            inputOnly
            size={"medium"}
            disabled={!useCustomEndpoint}
            value={customEndpoint}
            onChange={event => {
              onChange({ ...config, customEndpoint: event.target.value });
            }}
          />
        )}
      </Flex>
    </DataSourceSetupComposite>
  );
};
